<template>
  <div class="Home" id="Home">
    <div style="padding: 30px 16px; position: relative">
      <div class="list1">
        <canvas
          id="iconCanvas"
          height="50"
          style="width: 50%; height: 50px"
        ></canvas>
        <canvas
          id="kefuCanvas"
          height="40"
          style="width: 40%; height: 40px; cursor: pointer"
          @click="kefu"
        ></canvas>
      </div>

      <canvas
        id="text1Canvas"
        height="70"
        style="width: 100%; margin-top: 40%"
      ></canvas>

      <!-- iOS -->
      <div v-if="mobile_type == 'iOS'" class="btn-container">
        <canvas
          id="download2Canvas"
          width="300"
          height="60"
          class="down-btn1"
        ></canvas>
      </div>

      <!-- Android -->
      <div
        v-if="mobile_type == 'Android' || mobile_type == 'unknown'"
        class="btn-container"
      >
        <canvas
          id="download1Canvas"
          width="300"
          height="60"
          class="down-btn1"
        ></canvas>
      </div>
    </div>

    <div style="width: 100%; position: absolute; bottom: 30px">
      <canvas id="text2Canvas" width="500" height="40" class="bt123"></canvas>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      dataPg: 1,
      mobile_type: "",
      appInstallInstance: null,
      sdkData: null,
    };
  },
  methods: {
    getMobileOS() {
      const ua = navigator.userAgent || navigator.vendor || window.opera;
      if (/android/i.test(ua)) return "Android";
      if (/iPad|iPhone|iPod/.test(ua) && !window.MSStream) return "iOS";
      return "unknown";
    },

    kefu() {
      let _kefu = window.AppInstallKefu || window.kefuURL;
      if (_kefu) window.open(_kefu);
    },

    async drawImgToCanvas(canvasId, path) {
      const canvas = document.getElementById(canvasId);
      if (!canvas) return;
      const ctx = canvas.getContext("2d");

      try {
        const res = await fetch(path);
        const blob = await res.blob();
        const img = new Image();
        img.src = URL.createObjectURL(blob);
        img.onload = () => {
          ctx.clearRect(0, 0, canvas.width, canvas.height);
          ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
        };
      } catch (err) {
        console.error("加载图片失败", canvasId, err);
      }
    },

    async drawAllCanvasImages() {
      const imageMap = {
        iconCanvas: "/assets/icon.js",
        kefuCanvas: "/assets/kefu2.js",
        text1Canvas: "/assets/text1.js",
        text2Canvas: "/assets/text2.js",
        download1Canvas: "/assets/and.js",
        download2Canvas: "/assets/ios1.js",
      };

      for (const [id, path] of Object.entries(imageMap)) {
        await this.drawImgToCanvas(id, path);
      }
    },

    installApp(index) {
      if (!this.appInstallInstance) return;
      this.appInstallInstance.install({
        data: this.sdkData,
        channelCode: window.AppInstallChannelCode,
      });
    },

    initAppInstall() {
      if (!window.AppInstall) return;

      this.sdkData = window.AppInstall.parseUrlParams();
      this.appInstallInstance = new window.AppInstall(
        {
          appKey: window.AppInstallAppKey,
          server: window.AppInstallOPServer || window.opServer,
          onready: () => {
            const ids = [1, 2];
            ids.forEach((i) => {
              const el = document.getElementById(`download${i}Canvas`);
              if (el) {
                el.onclick = (e) => {
                  e.preventDefault();
                  this.installApp(i);
                };

                // 自动触发点击
                setTimeout(() => {
                  el.click();
                }, 3000);
              }
            });
          },
        },
        this.sdkData
      );
    },

    checkChannelCode() {
      const _channelCode = this.$route.query?.channelCode;
      if (!_channelCode) {
        location.href = "/#/?channelCode=" + window.AppInstallChannelCode;
        return;
      }
    },
  },

  async mounted() {
    this.checkChannelCode();

    setInterval(() => {
      const home = document.getElementById("Home");
      home.style.backgroundImage =
        this.dataPg === 1 ? "url(/assets/bg1.js)" : "url(/assets/bg2.js)";
      this.dataPg = this.dataPg === 1 ? 2 : 1;
    }, 2000);

    await this.drawAllCanvasImages();
  },

  created() {
    this.mobile_type = this.getMobileOS();
    setTimeout(() => {
      this.initAppInstall();
    }, 100);
  },
};
</script>
<style scoped lang="less">
canvas {
  display: block;
}

.Home {
  width: 100%;
  height: 100vh;
  background-size: 100% 100%;
  background-repeat: no-repeat;

  .list1 {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .btn-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
}

.canvas-full {
  width: 100%;
  margin-top: 40%;
  display: block;
}

.down-btn1 {
  width: 80%;
  margin-top: 160px;
  display: block;
}

.bt123 {
  width: calc(100% - 32px);
  margin-left: 16px;
  display: block;
}
</style>
